import { inject, Pipe, PipeTransform } from '@angular/core';

import { FeatureFlagsService } from './feature-flags.service';

@Pipe({
  name: 'featureFlag',
  standalone: true,
  pure: false,
})
export class FeatureFlagPipe implements PipeTransform {
  private readonly service = inject(FeatureFlagsService);

  public transform(key: string): boolean {
    return this.service.enabled(key);
  }
}
